import { ClientGeoAreaGeoAreaTypeEnum } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { LocalizationNameSpace } from '@/localization/types/localizationTypes';

const KNOWN_GEO_AREA_TYPES: readonly ClientGeoAreaGeoAreaTypeEnum[] =
  Object.values(ClientGeoAreaGeoAreaTypeEnum);

/**
 * Returns a function that maps a {@link ClientGeoAreaGeoAreaTypeEnum} to its localized label.
 * Unknown/undefined types fall back to the raw value (or undefined when no type is given).
 */
export const useGeoAreaTypeLabel = () => {
  const { t } = useTranslation(LocalizationNameSpace.GEO_AREA, {
    keyPrefix: 'geoAreaTypeLabels'
  });

  return useCallback(
    (geoAreaType?: ClientGeoAreaGeoAreaTypeEnum): string | undefined => {
      if (!geoAreaType) return undefined;
      return KNOWN_GEO_AREA_TYPES.includes(geoAreaType)
        ? t(geoAreaType)
        : geoAreaType;
    },
    [t]
  );
};
